/* eslint-disable no-shadow */
const state = () => ({
});

// getters
const getters = {
};

  // actions
const actions = {
  handleUL({ state, rootState, rootGetters }, { vueRouter, eventData }) {
    vueRouter.push({
      path: eventData.path,
      query: eventData.params,
    });
  },
};

  // mutations
const mutations = {
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/universalLinks.js